var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.61133 8.65039H9.66688",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.61133 11.6504H7.77466",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.05577 4H8.94466C10.3891 4 10.3891 3.25 10.3891 2.5C10.3891 1 9.66688 1 8.94466 1H6.05577C5.33355 1 4.61133 1 4.61133 2.5C4.61133 4 5.33355 4 6.05577 4Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3889 2.51562C12.7939 2.65062 14 3.57312 14 7.00062V11.5006C14 14.5006 13.2778 16.0006 9.66667 16.0006H5.33333C1.72222 16.0006 1 14.5006 1 11.5006V7.00062C1 3.58062 2.20611 2.65062 4.61111 2.51562",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.93d8d044ecf455f2d0bd43d939847ace.svg";
export { ForwardRef as ReactComponent };